import { render, staticRenderFns } from "./ActivitieProdGrid.vue?vue&type=template&id=fbff3a38&scoped=true&lang=pug&"
import script from "./ActivitieProdGrid.vue?vue&type=script&lang=js&"
export * from "./ActivitieProdGrid.vue?vue&type=script&lang=js&"
import style0 from "./ActivitieProdGrid.vue?vue&type=style&index=0&id=fbff3a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbff3a38",
  null
  
)

export default component.exports